import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { inr } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { imgUrl } from "@/components/ImageUploader";

export default function ProductCard({ p }) {
  const { has, toggle } = useWishlist();
  return (
    <div className="group hover-lift bg-white" data-testid={`product-card-${p.id}`}>
      <Link to={`/product/${p.slug}`} className="block relative aspect-[3/4] overflow-hidden bg-[#FCE4EC]" data-testid={`product-link-${p.id}`}>
        <img src={imgUrl(p.images?.[0])} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {p.compare_at_price && p.compare_at_price > p.price && (
          <div className="absolute top-3 left-3 bg-[#D4AF37] text-[#0B1F3A] text-[10px] px-2 py-1 tracking-widest font-semibold">
            −{Math.round((1 - p.price / p.compare_at_price) * 100)}%
          </div>
        )}
        <button onClick={(e) => { e.preventDefault(); toggle(p.id); }}
          className="absolute top-3 right-3 w-9 h-9 bg-white/90 flex items-center justify-center hover:bg-white"
          data-testid={`wishlist-toggle-${p.id}`}>
          <Heart size={16} fill={has(p.id) ? "#D4AF37" : "none"} color={has(p.id) ? "#D4AF37" : "#0B1F3A"} />
        </button>
      </Link>
      <div className="p-2.5 md:p-4">
        <div className="eyebrow text-[9px] md:text-xs mb-1">{p.subcategory}</div>
        <div className="font-serif text-[13px] md:text-base text-[#0B1F3A] leading-snug line-clamp-2 min-h-[2.4em]">{p.name}</div>
        <div className="flex items-baseline gap-2 mt-1.5 md:mt-2">
          <span className="text-[#D4AF37] font-semibold text-sm md:text-base">{inr(p.price)}</span>
          {p.compare_at_price && p.compare_at_price > p.price && (
            <span className="text-[10px] md:text-xs text-[#1E293B]/40 line-through">{inr(p.compare_at_price)}</span>
          )}
        </div>
      </div>
    </div>
  );
}
